<template>
  <v-container>
    <v-breadcrumbs class="pa-0 ma-0" :items="breadcrumbs"></v-breadcrumbs>
        <from-ot :id="id" @CrearOT="CrearOT"></from-ot>
  </v-container>
</template>

<script>
import formatFecha from '@/mixins/formatFecha';
import upperCase from '@/mixins/upperCase';
import { mapGetters } from 'vuex'

export default {
  mixins: [formatFecha,upperCase],
  components:{
    FromOt: () => import('@/components/ordenservicio/fromOt.vue'),
  },
  computed: {
    ...mapGetters(['getIDE']),
    breadcrumbs() {
        return [
        { text: 'Visor membresias', disabled: false, href: `/visor-membresias/${this.id}` },
        { text: this.$route.meta.title || this.$route.name, disabled: true }
        ];
    }
  },
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      orden: null,
    };
  },
  methods: {
    CrearOT(data){
      var membresia = data.membresia
        this.$http.post(`ordenservicio`,{
            Referencia: data.membresia,
            Descripcion: data.descripcion,
            CodMov: data.tipo,
            user_id: this.getIDE
        })
        .then(response => {
            if (response.status === 200) {
                if (response.data) {
                    this.$swal.fire({
                        position: 'center',
                        html: `Se ha creado correctamente la orden de servicio con folio: ${response.data} <br/> Se notificará cuando se halla <strong>Autorizado</strong>`,
                        icon: 'success',
                        confirmButtonText: 'De acuerdo',
                        showCloseButton: false,
                        showConfirmButton: true,
                        backdrop: false,
                        customClass: {
                            confirmButton: 'v-btn v-btn--contained theme--light v-size--default boton-vuetify',
                            closeButton: 'v-btn boton-close'
                        },
                        buttonsStyling: false  // importante para que las clases funcionen
                    }).then(() => {
                        // Redirige a la ruta deseada
                        this.$router.push(`/visor-membresias/${membresia}`); // cambia '/otra-ruta' por la ruta que necesites
                    });
                }
            }
        }).catch((err) => {
            let mensajeError = 'Ups, tuvimos un error no esperado. <b>Intenta más tarde</b>.';

            if (err.response) {
                console.log(err.response)
                mensajeError = err.response.data?.mensaje
                /*
                const detalles = err.response.data?.details;

                if (Array.isArray(detalles) && detalles.length > 0) {
                    // Muestra los mensajes de detalle que da Conekta
                    mensajeError = detalles.map(e => `<p>${e.message}</p>`).join('');
                } else if (err.response.data?.message) {
                    mensajeError = `<p>${err.response.data.message}</p>`;
                }
                    */
            }

            this.$swal.fire({
                position: 'center',
                html: mensajeError,
                icon: 'error',
                confirmButtonText: 'Cerrar',
                showCloseButton: true,
                showConfirmButton: true,
                backdrop: false
            });
        });
    }
  },
};
</script>
